import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import { Content, Layout } from './styles'

export const DetailsSectionSkeleton = () => (
  <Layout>
    <Content>
      <Skeleton height='27px' />
      <Spacer height={5} />
      <Skeleton height='27px' />
      <Spacer height={21} />
      <Skeleton height='16px' width='80px' />
      <Spacer height={39} />
      <Skeleton height='10px' width='110px' />
      <Spacer height={15} />
      <Skeleton height='21px' />
      <Spacer height={27} />
      <Skeleton height='11px' />
      <Spacer height={13} />
      <Skeleton height='34px' />
      <Spacer height={7} />
      <Skeleton height='33px' />
      <Spacer height={45} />
      <Skeleton height='1px' />
      <Spacer height={21} />
      <Skeleton height='26px' />
      <Spacer height={21} />
      <Skeleton height='44px' />
      <Spacer height={17} />
      <Skeleton height='17px' />
      <Spacer height={24} />
      <Skeleton height='10px' />
      <Spacer height={23} />
      <Skeleton height='1px' />
      <Spacer height={26} />
      <Skeleton height='10px' />
      <Spacer height={26} />
      <Skeleton height='1px' />
      <Spacer height={24} />
      <Skeleton height='10px' />
      <Spacer height={27} />
      <Skeleton height='1px' />
      <Spacer height={23} />
      <Skeleton height='13px' />
      <Spacer height={23} />
      <Skeleton height='1px' />
      <Spacer height={21} />
      <Skeleton height='13px' />
      <Spacer height={21} />
      <Skeleton height='26px' />
      <Spacer height={72} />
    </Content>
  </Layout>
)
